import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Link } from 'foundations-components/transitional/components/Link';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { footerLinks } from './footerLinks';
import { appendHubsContent } from '../../../../utils/urls';
import { getPublicLang } from 'academy-common-lib/utils/url';
import usageTracker from '../../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LinkStyle = styled.div.withConfig({
  displayName: "LegalLinks__LinkStyle",
  componentId: "uwvi5r-0"
})(() => ({
  ul: {
    justifyContent: 'center !important'
  }
}));
const LinkHovered = styled.div.withConfig({
  displayName: "LegalLinks__LinkHovered",
  componentId: "uwvi5r-1"
})(({
  theme
}) => ({
  '&:hover': {
    color: theme.color['text-interactive-on-fill-hover']
  }
}));
const StyledCookieSettings = styled.div.withConfig({
  displayName: "LegalLinks__StyledCookieSettings",
  componentId: "uwvi5r-2"
})(({
  theme
}) => ({
  a: {
    textDecoration: 'none !important',
    color: theme.color['do-not-use-battleship'],
    fontSize: '16px !important',
    '&:hover': {
      color: theme.color['text-interactive-on-fill-hover']
    }
  }
}));
const RenderHoverLinks = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Paragraph, {
    color: "do-not-use-battleship",
    margin: "0",
    textAlign: "center",
    typography: "heading-100",
    children: /*#__PURE__*/_jsx(LinkHovered, {
      children: children
    })
  });
};
const publicLang = getPublicLang();
const LegalLinks = () => {
  const {
    isNotLaptop
  } = useMediaQuery('notLaptop');
  return /*#__PURE__*/_jsx(TFlex, {
    inlineSize: "100%",
    justifyContent: isNotLaptop ? 'end' : 'center',
    textAlign: "center",
    wrap: "wrap",
    children: /*#__PURE__*/_jsx(LinkStyle, {
      children: /*#__PURE__*/_jsxs(List, {
        inline: true,
        marginBlockEnd: "900",
        children: [/*#__PURE__*/_jsx(ListItem, {
          paddingBlock: "200",
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(Link, {
            href: appendHubsContent(footerLinks.LEGAL_STUFF.hrefs[publicLang] || footerLinks.LEGAL_STUFF.hrefs.en, I18n.text(footerLinks.LEGAL_STUFF.i18nKey)),
            onClick: () => {
              usageTracker.track('navInteraction', {
                action: 'footer-legal-click'
              });
            },
            use: "unstyled",
            children: /*#__PURE__*/_jsx(RenderHoverLinks, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: footerLinks.LEGAL_STUFF.i18nKey
              })
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          paddingBlock: "200",
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(Link, {
            href: appendHubsContent(footerLinks.PRIVACY_POLICY.hrefs[publicLang] || footerLinks.PRIVACY_POLICY.hrefs.en, I18n.text(footerLinks.PRIVACY_POLICY.i18nKey)),
            onClick: () => {
              usageTracker.track('navInteraction', {
                action: 'footer-privacy-click'
              });
            },
            use: "unstyled",
            children: /*#__PURE__*/_jsx(RenderHoverLinks, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: footerLinks.PRIVACY_POLICY.i18nKey
              })
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          paddingBlock: "200",
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(StyledCookieSettings, {
            children: /*#__PURE__*/_jsx("span", {
              className: "hs-footer-cookie-settings",
              hidden: true,
              children: /*#__PURE__*/_jsx(Link, {
                href: "#",
                onClick: () => {
                  usageTracker.track('navInteraction', {
                    action: 'footer-cookies-click'
                  });
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.publicFooter.cookies"
                })
              })
            })
          })
        })]
      })
    })
  });
};
export default LegalLinks;